import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCommonApi } from '../../api';
import { onSuccessCustomApiResponse } from '../../api/utils';

export const useRemoveAccidentFile = ({
  accidentId
}: {
  accidentId: number;
}) => {
  const queryClient = useQueryClient();

  const { mutate: removeFile, isPending: isRemoving } = useMutation(useCommonApi().deleteAccidentFile());

  const handleRemoveFile = (template: string, id: number) => {
    removeFile(
      { accidentId: accidentId?.toString(), template, id },
      {
        onSuccess: onSuccessCustomApiResponse({
          executed: async () => {
            await queryClient.invalidateQueries({
              queryKey: ['common', 'accidents', 'detail', accidentId.toString()]
            });
          }
        })
      }
    );
  };

  return { handleRemoveFile, isRemoving };
};
